import { render } from "./EllipsisLoader.vue?vue&type=template&id=37641d0a&scoped=true&ts=true"
import script from "./EllipsisLoader.vue?vue&type=script&lang=ts"
export * from "./EllipsisLoader.vue?vue&type=script&lang=ts"

import "./EllipsisLoader.vue?vue&type=style&index=0&id=37641d0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37641d0a"]])

export default __exports__